import { BaseMutations } from '@/store/base-mutations';
import { TableFilterItem, PaginationProps, TableOptions } from '@/types';
import { Clients } from '../types';
import ClientsState from './state';
import { default_client } from '../services';

export default class ClientsMutations extends BaseMutations<ClientsState> {
  SET_CLIENTS(data: Clients.ClientListItem[]) {
    this.state.clients = data;
  }

  SET_LOADING(value: boolean) {
    this.state.clients_loading = value;
  }

  SET_CITIES(filters: string[] | null) {
    this.state.cities = filters === null ? [] : filters;
  }

  SET_ORGANIZATION_TYPES(filters: TableFilterItem[] | null) {
    this.state.organization_types = filters === null ? [] : filters;
  }

  SET_FILTERS(filters: Clients.RequestFilters) {
    this.state.filters = filters;
  }

  CLEAR_CLIENT() {
    this.state.current_client = default_client();
  }

  SET_CLIENTS_TO_ADD(data: Clients.ClientToAddItem[]) {
    this.state.clients_to_add = data;
  }

  UPD_CLIENTS_TO_ADD_REQUEST_FILTER_KEY({ key, value }: { key: keyof Clients.ClientsToAddRequestFilters, value: string }) {
    this.state.clients_to_add_filters[key] = value;
  }

  SET_CLIENTS_TO_ADD_LOADING(value: boolean) {
    this.state.clients_to_add_loading = value;
  }

  SET_CLIENTS_TO_ADD_TABLE_OPTIONS(opts: TableOptions) {
    this.state.clients_to_add_table_options = opts;
  }

  UPD_CLIENTS_TO_ADD_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.clients_to_add_table_options[key] = value;
  }

  UPD_CLIENTS_TO_ADD_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.clients_to_add_pagination_props[key] = value;
  }
}
